// React
import React from 'react';

// Components
import { MpsButton } from '@mobilitystore/components-interface';
import { CDN_LINK } from '../../assets/img';


const LoanOverview = ({
  className = '',
  header,
  description,
  gateText,
  imageSrc,
  onLoginClick,
  onRegisterClick,
  loginLabel,
  registerPrompt,
  registerLabel
}) => (
  <div className={`a-box mps-overview ${className}`}>
    <div className='e-container mps-overview__container'>
      <div className='mps-overview__container__content'>
        <div className='mps-overview__text'>
          <h1 className='mps-overview__text__heading'>{header}</h1>
          <div className='mps-overview__text__desc'>
            <p>{description}</p>
            <p>{gateText}</p>
          </div>
          <div className='mps-overview__button'>
            <MpsButton label={loginLabel} mode='primary' onClick={onLoginClick} />
          </div>
          <div className='mps-overview__register'>
            <span>{registerPrompt} </span>
            <button
            type='button'
            className='a-button a-button--integrated loan-application__register-link'
            onClick={onRegisterClick}
          >
            {registerLabel}
          </button>
          </div>
          
        </div>

        {imageSrc && (
          <div className='mps-overview__video'>
            <img src={`${CDN_LINK}/seller/${imageSrc}`} alt='' />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default LoanOverview;
